import { Box, Button, Flex, Grid, GridItem, Image, Input, Text, Textarea, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { CheckIcon } from '@chakra-ui/icons'
import { useForm } from 'react-hook-form'
import { SUBMIT_PROPERTY_MUTATION } from '../../Components/Graphql/Mutations'
import { useMutation } from '@apollo/client';

const SubmitYourProperty = () => {
  const toast = useToast();
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState(null);

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const [submitPropertyMutation, submitProperty] = useMutation(SUBMIT_PROPERTY_MUTATION);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    // Check if a file is selected
    if (!file) {
      setSelectedFile(null);
      setError(null);
      return;
    }

    // Check the file size (in bytes)
    const maxSizeInBytes = 1024 * 1024; // 1 MB
    if (file.size > maxSizeInBytes) {
      setError('File size exceeds the limit (1MB)');
      setSelectedFile(null);
    } else {
      setError(null);
      setSelectedFile(file);
    }
  };

  useEffect(() => {

    console.log("error:", submitProperty.error)
    console.log("loading:", submitProperty.loading)
    console.log("data:", submitProperty.data)

    if (submitProperty.data != undefined) {
      toast({
        title: 'Succeed',
        description: 'Property Submitted Successfully',
        status: 'success',
        duration: 4000,
        isClosable: true
      });
      // localStorage.setItem("userAddress", data.getAddress)
      // navigate('/dashboard');
    }
    if (submitProperty.error != undefined) {
      toast({
        title: 'error',
        description: submitProperty.error.message,
        status: 'error',
        duration: 4000,
        isClosable: true
      });
    }
  }, [submitProperty.data, submitProperty.loading, submitProperty.error])

  const onSubmit = async (data) => {
    try{
      console.log("Data after submitting: ", data);
      const submitPropertyInput = {
        name: data.propertyName,
        location: data.propertyLocation,
        description: data.propertyDescription,
        firstName: data.firstName,
        lastName: data.lastName,
        phoneNumber: data.phoneNumber,
        email: data.email,
        images: [data.propertyImages[0].name]
      };
      console.log(submitPropertyInput);
      await submitPropertyMutation({ variables: submitPropertyInput });
    } catch(error) {
      // toast({
      //   title: 'Error',
      //   description: error.message,
      //   status: 'error',
      //   duration: 4000,
      //   isClosable: true
      // });
      console.log("Error from submit property mutation: ", error);
    }

  }

  return (
    <Box>
      <Box display='flex' alignItems='center' justifyContent='center' flexDirection='column'>
        <Box background='linear-gradient(to right, #1F5B94, #1993C2, #1899C7)' w='100%' display='flex' alignItems='center' justifyContent='center' padding='25px 0px'>
          <Box w={{ base: '100%', sm: '80%', lg: '40%', '2xl': '30%' }}>
            <Text fontSize={{ base: '23px', sm: '3xl' }} align='center' color='white'>
              Recapitalize Your Property &
            </Text>
            <Text fontSize={{ base: '23px', sm: '3xl' }} align='center' color='white'>
              Earn Liquidity at Asset Tokenization CRE
            </Text>
            <Text fontSize={{ base: '18px', md: '22px' }} align='center' color='white'>
              Submit your cre property below
            </Text>
          </Box>
        </Box>
        <Box maxWidth='1086px' marginTop='100px' padding='0px 25px' w='100%'>
          <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }} gap={20}>
            <GridItem w='100%' order={{ base: 2, md: 1 }}>
              <Box w='100%'>
                <Text
                  color='#1F508B'
                  fontSize='25px'
                  fontWeight={300}
                >
                  Submit your commercial property and discover how we can tokenize it for you.
                </Text>
                <Text
                  fontSize='18px'
                  color='#1F508B'
                  marginTop='40px'
                >
                  Our team is ready to tokenize your property on our CRE Marketplace. Asset Tokenization CRE accepts commercial properties from across the US and we are always looking to assist sponsors in leveraging our network to raise capital. Please complete the form to submit your property.
                </Text>
                <Text
                  marginTop='40px'
                  color='#1F508B'
                  fontSize='25px'
                  fontWeight={300}
                >
                  Benefits of Submitting a Property
                </Text>
                <Box marginTop='40px'>
                  <Flex alignItems='center' gap='6px'>
                    <CheckIcon color='#1F508B' />
                    <Text
                      fontSize='18px'
                      color='#1F508B'
                    >
                      Property Owners who want to recapitalize their assets can have the benefit of not needing to fully sell their properties and can put up to 90% of their equity up for accredited investors
                    </Text>
                  </Flex>
                  <Flex alignItems='center' gap='6px' marginTop='30px'>
                    <CheckIcon color='#1F508B' />
                    <Text
                      fontSize='18px'
                      color='#1F508B'
                    >
                      Maintain your GP status, management of your property and remaining interests
                    </Text>
                  </Flex>
                  <Flex alignItems='center' gap='6px' marginTop='30px'>
                    <CheckIcon color='#1F508B' />
                    <Text
                      fontSize='18px'
                      color='#1F508B'
                    >
                      Continue to collect management fees
                    </Text>
                  </Flex>
                </Box>
                <Image
                  src={'https://redswan.io/wp-content/uploads/2022/06/pexels-zachary-debottis-1838640-scaled.jpg'}
                  width='443px'
                  height='383px'
                  marginTop='40px'
                />
              </Box>
            </GridItem>
            <GridItem w='100%' order={{ base: 1, md: 2 }}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Text
                  color='#1F508B'
                  fontSize='25px'
                  fontWeight={300}
                >
                  Our team assesses all submitted properties and projects for listing on our marketplace.
                </Text>
                <Box marginTop='40px'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    marginBottom='8px'
                    color='#1F508B'
                  >
                    Name
                  </Text>
                  <Flex flexDirection={{ base: 'column', md: 'row' }} gap='8px'>
                    <Box w='100%'>
                      <Input
                        placeholder='Enter your First Name'
                        {...register('firstName', {
                          required: 'Frist name is required'
                        })}
                      />
                      {errors.firstName && (
                        <Text color='red'>{errors.firstName.message}</Text>
                      )}
                    </Box>
                    <Box w='100%'>
                      <Input
                        placeholder='Enter your Last Name'
                        {...register("lastName", {
                          required: 'Last name is required'
                        })}
                      />
                      {errors.lastName && (
                        <Text color='red'>{errors.lastName.message}</Text>
                      )}
                    </Box>
                  </Flex>
                </Box>
                <Box marginTop='40px'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    marginBottom='8px'
                    color='#1F508B'
                  >
                    Phone Number
                  </Text>
                  <Input
                    placeholder='Phone Number'
                    {...register('phoneNumber', {
                      required: 'Phone number is required'
                    })}
                  />
                  {errors.phoneNumber && (
                    <Text color='red'>{errors.phoneNumber.message}</Text>
                  )}
                </Box>
                <Box marginTop='40px'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    marginBottom='8px'
                    color='#1F508B'
                  >
                    Email
                  </Text>
                  <Input
                    placeholder='Enter your Email'
                    {...register('email', {
                      required: 'Email is required',
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: 'Invalid email format',
                      },
                    })}
                  />
                </Box>
                {errors.email && (
                  <Text color='red'>{errors.email.message}</Text>
                )}
                <Box marginTop='40px'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    marginBottom='8px'
                    color='#1F508B'
                  >
                    Name of Property
                  </Text>
                  <Input
                    placeholder='Enter the name of the Property'
                    {...register("propertyName", {
                      required: 'Property name is required'
                    })}
                  />
                  {errors.propertyName && (
                    <Text color='red'>{errors.propertyName.message}</Text>
                  )}
                </Box>
                <Box marginTop='40px'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    marginBottom='8px'
                    color='#1F508B'
                  >
                    Property Location
                  </Text>
                  <Input
                    placeholder='Enter the location of the Property'
                    {...register('propertyLocation', {
                      required: 'Property location is required'
                    })}
                  />
                  {errors.propertyLocation && (
                    <Text color='red'>{errors.propertyLocation.message}</Text>
                  )}
                </Box>
                <Box marginTop='40px'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    marginBottom='8px'
                    color='#1F508B'
                  >
                    Enter the Description of your Property
                  </Text>
                  <Textarea
                    placeholder='Enter the Description of your Property'
                    {...register('propertyDescription', {
                      required: 'Property Description is required'
                    })}
                  />
                  {errors.propertyDescription && (
                    <Text color='red'>{errors.propertyDescription.message}</Text>
                  )}
                </Box>
                <Box marginTop='40px'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    marginBottom='8px'
                    color='#1F508B'
                  >
                    File
                  </Text>
                  <Input
                    {...register('propertyImages', {
                      required: 'Please add property images'
                    })}
                    type='file'
                    border='none'
                    padding='0px'
                    borderRadius='0px'
                    onChange={handleFileChange}
                  />
                  {errors.propertyImages && <Text color="red">{errors.propertyImages.message}</Text>}
                </Box>
                <Button
                  marginTop='40px'
                  width='100%'
                  type='submit'
                  bgColor='#002B5B'
                  color='#FFFFFF'
                  _hover={{
                    bgColor: '#1C3E64'
                  }}
                >
                  Submit
                </Button>
              </form>
            </GridItem>
          </Grid>
        </Box>
        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
          w='100%'
          background='linear-gradient(to right, #1F5B94, #1993C2, #1899C7)'
          marginTop='100px'
          padding='40px 0px'
          flexDirection='column'
        >
          <Text color='white' fontSize={{ base: '23px', md: '35px' }} textAlign='center'>
            Are you an accredited investor?
          </Text>
          <Button
            bgColor='white'
            color='blue'
            padding='20px 40px'
            borderRadius='0px'
            fontWeight='300'
            marginTop='30px'
          >
            Sign up for the Marketplace
          </Button>
        </Box>
      </Box >
    </Box >
  )
}

export default SubmitYourProperty